import React from "react";
import ReactDOM from "react-dom";
import {forceBoolean, optional, parseBoolean} from "../../utils/lang";
import _ from "underscore";
import { isEmpty, isNotEmpty } from "../../framework/utils";
import Actions from "./mobile/actions";

export const DIALOG_RESULT_OK = 0
export const DIALOG_RESULT_CANCEL = 1

export class Dialog extends React.Component {

    constructor(props) {
        super(props)

        this.opened = false
        this.dialogResult = DIALOG_RESULT_CANCEL
    }

    componentDidMount() {
        let me = ReactDOM.findDOMNode(this)
        $(me)
            .modal({show: false})
            .on("show.bs.modal", () => {
                this.opened = true
                if (_.isFunction(this.props.onShow)) {
                    this.props.onShow()
                }
            })
            .on("shown.bs.modal", () => {
                this.opened = true
                this.checkVisibility();
                if (_.isFunction(this.props.onShown)) {
                    this.props.onShown()
                }
            })
            .on("hide.bs.modal", (e) => {
                if (forceBoolean(this.props.notHide)) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            })
            .on("hidden.bs.modal", e => {
                this.opened = false
                if (_.isFunction(this.props.onClose)) {
                    this.props.onClose(this.dialogResult)
                }
                this.dialogResult = DIALOG_RESULT_CANCEL;
            })
            
        this.checkVisibility();
    }

    componentDidUpdate() {
        this.checkVisibility();
    }

    checkVisibility() {
        if (!this.props.hidden) {
            if (!this.opened) {
                this.opened = true
                this.show()
            }
        } else {
            if (this.opened) {
                this.opened = false
                this.hide()
            }
        }
    }

    show() {
        let me = ReactDOM.findDOMNode(this)
        $(me).modal("show")
    }

    hide() {
        let me = ReactDOM.findDOMNode(this)
        $(me).modal("hide")
    }

    isMobile() {
        return parseBoolean(optional(this.props.mobile, false));
    }

    runButtonAction(button) {
        this.dialogResult = optional(button.dialogResult, DIALOG_RESULT_CANCEL)
        button.action(this)
    }

    getHeaderComponent() {
        return this.isMobile() ? MobileDialogHeader : DialogHeader;
    }

    getButtons() {
        const _buttons = optional(this.props.buttons, []),
            buttons = [],
            buttonMapper = (b, className) => {
                    const _className = className || "btn-primary";

                    return (<button
                        key={b.text}
                        type="button"
                        className={"btn btn-sm " + _className + " " + optional(b.extraClassName, "")}
                        onClick={this.runButtonAction.bind(this, b)}
                    >
                        {b.text}
                    </button>)
                }

        if (isEmpty(_buttons)) {
            return [];
        } else if (_.isArray(_buttons)) {
            buttons.push(<div key="modal-btn-spacer" className="flex-grow-1"/>);
            _.each(_buttons, b => {
                buttons.push(buttonMapper(b));
            })
        } else {
            const _leftButtons = optional(() => _buttons.left, []),
                _rightButtons = optional(() => _buttons.right, []);

            _.each(_leftButtons, b => buttons.push(buttonMapper(b, "btn-transparent-secondary")));
            buttons.push(<div key="modal-btn-spacer" className="flex-grow-1"/>)
            _.each(_rightButtons, b => buttons.push(buttonMapper(b)));
        }
        
        return buttons;
    }

    render() {
        const mobile = this.isMobile(),
            large = parseBoolean(optional(this.props.large, false)),
            buttons = this.getButtons(),
            style = {
                //display: this.props.hidden ? "none" : "block"
            },
            headerHidden = parseBoolean(optional(this.props.headerHidden, false)),
            HeaderComponent = this.getHeaderComponent(),
            bodyStyle = {
                padding: this.props.noPadding ? "0px" : undefined
            };

        let modalDialogClassName = "modal-dialog"
        if (large) {
            modalDialogClassName += " modal-lg"
        }
        if (mobile) {
            modalDialogClassName += " modal-dialog-centered modal-dialog--mobile"
        }

        return (
            <div className="modal fade" role="dialog" tabIndex="-1" style={style}>
                <div className={modalDialogClassName}>
                    <div className="modal-content">
                        {!headerHidden &&
                            <HeaderComponent
                                {...this.props}
                                runButtonAction={this.runButtonAction.bind(this)}
                            />
                        }
                        <div className="modal-body" style={bodyStyle}>
                            {this.props.children}
                        </div>
                        {isNotEmpty(buttons) && <div className="modal-footer">
                            {buttons}
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}

class DialogHeader extends React.Component {
    render() {
        return(
            <div className="modal-header">
                <div className="modal-title h5">
                    {this.props.title}
                </div>
            </div>
        )
    }
}

class MobileDialogHeader extends React.Component {

    getTitle() {
        const title = this.props.title;
        return _.isFunction(title) ? title() : title;
    }

    onActionClick(callback, result) {
        const syntheticButton = {
            dialogResult: result,
            action: callback && _.isFunction(callback) ? callback : () => {},
        };

        if (this.props.runButtonAction && _.isFunction(this.props.runButtonAction)) {
            this.props.runButtonAction(syntheticButton);
        }
    }

    mapActions(actions) {
        return _.map(optional(actions, []), a => {
            const mappedAction = _.omit(a, "onClick"),
                callback = a.onClick,
                dialogResult = optional(a.dialogResult, DIALOG_RESULT_CANCEL);

            return _.extend(
                mappedAction,
                {
                    onClick: () => this.onActionClick(callback, dialogResult),
                }
            )
        })
    }

    render() {
        const leftHeaderActions = this.mapActions(optional(this.props.leftHeaderActions, [])),
            rightHeaderActions = this.mapActions(optional(this.props.rightHeaderActions, [])),
            title = this.props.title,
            subtitle = this.props.subtitle,
            hasHeader = isNotEmpty(title) || isNotEmpty(subtitle);

        return(
            <>
                <div className="modal-header">
                    {isNotEmpty(leftHeaderActions) && <div
                        className="modal-header__actions"
                    >
                        <Actions
                            actions={leftHeaderActions}
                        />
                    </div>}
                    <div className="modal-header__spacer"/>
                    {isNotEmpty(title) && <div className="hidden-xs-down modal-header__title">
                        {title}
                    </div>}
                    <div className="modal-header__spacer"/>
                    {isNotEmpty(rightHeaderActions) && <div
                        className="modal-header__actions"
                    >
                        <Actions
                            actions={rightHeaderActions}
                        />
                    </div>}
                </div>
                {hasHeader && <div
                    className="modal-content-header"
                >
                    <div/>
                    {isNotEmpty(title) && <h2
                        className="modal-content-header__title hidden-sm-up"
                    >
                        {title}
                    </h2>}
                    {isNotEmpty(subtitle) && <div
                        className="modal-content-header__subtitle"
                    >
                        {subtitle}
                    </div>}
                </div>}
            </>
        )
    }
}